import AbmMotivosRechazoOrden from "../../components/textos/AbmMotivosRechazoOrden/AbmMotivosRechazoOrden";

export const configTable = {
    urls: [
        "/Texto/GetByIdTipoTexto/15?Pagina=1&RegistrosPorPagina=-1", // GET
        "/Texto", // POST 
        "/Texto", // PUT
        "/Texto" // DELETE
    ],
    grid: {
        columnConfig: ["id","nombre", "descripcion"], 
        searchField: ["nombre", "id", "descripcion"]
    },
    Abm: AbmMotivosRechazoOrden,
    textSize: 10
}